export const PATH_LOCATIONS_LIMIT = 100
export const PATH_LOCATIONS_FADING_FACTOR = 3
